/** Identifies this app to the context service and the AI infra (`applicationId` there). */
export const APPLICATION_ID = "solutions";

/** Most events the browser may send in one request. */
export const MAX_EVENTS_PER_BATCH = 50;

/** Caps on the rolling lists kept in a context snapshot, so a snapshot stays prompt-sized. */
export const SNAPSHOT_LIMITS = {
	recentPages: 20,
	recentEntities: 15,
	searches: 10,
	documents: 10,
	ctas: 10,
	advisorConversations: 10,
	/**
	 * Ids of the newest applied events, so a redelivered message is not applied twice. SQS FIFO holds a
	 * subject's group while its messages are in flight, so a redelivery never trails by more than a batch.
	 */
	appliedEventIds: 100
} as const;

/** The content-architecture entities activity can be about (docs/content-architecture.md). */
export const ENTITY_KINDS = ["company", "project", "solution", "model", "build", "insights", "document"] as const;
